export const jira_issue_link = process.env.REACT_APP_JIRA_ISSUE_LINK;